import React from 'react'
import PropTypes from 'prop-types'

import ItemsListingWrapper from 'Pods/ItemsListing/ItemsListingWrapper'

function DesignersItems({ cart, userItems }) {
  return (
    <div className="user-models">
      <ItemsListingWrapper
        perRowType="designers"
        gaList="Designers List"
        cart={cart}
        data={userItems}
        isWithCarousel
      />
    </div>
  )
}

DesignersItems.propTypes = {
  cart: PropTypes.object.isRequired,
  userItems: PropTypes.array,
}

export default DesignersItems
